import React, { useEffect, useState } from 'react';

import axios from 'axios';

import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import 'moment/locale/ko';
import Pagination from '@mui/material/Pagination';
import Container from '@mui/material/Container';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { authAtom } from '../../_state';
import LockIcon from '@mui/icons-material/Lock';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 16;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

export default function List(props) {
  const auth = useRecoilValue(authAtom);

  const { name, kind, category, file, columns } = props;
  const [srchData, setSrchData] = useState({});
  const [rows, setRows] = useState([]);
  const [noticeRows, setNoticeRows] = useState([]);
  const [pageCnt, setPageCnt] = useState(1);
  const [page, setPage] = useState(1);
  const [offset] = useState(10);
  const [progItem, setProgItem] = useState([]);
  const [progSelected, setProgSelected] = useState([]);

  const navigate = useNavigate();

  const handleChangeSrch = (e) => {
    let id = e.target.id.replace('Srch', '');
    setSrchData({ ...srchData, [id]: e.target.value });
  };

  const handleRowClick = (data) => (evt) => {
    console.log(data);
    if (data.is_secret) {
      if (auth.role !== 'ROLE_ADMIN' && auth.userid !== data.top_created_id) {
        return;
      }
    }
    navigate('/detail', {
      state: {
        name,
        kind,
        id: data.id,
        categoryItem: progItem
      }
    });
  };

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const getDataList = async (e) => {
    const { subject, createdId } = srchData;
    let params = {
      offset,
      page,
      limit: offset,
      subject,
      createdId,
      kind,
      category: progSelected,
      isNotice: false
    };

    const response = await axios.get(`/api/board/${kind}`, { params });
    if (response.data) {
      const result = response.data;
      setPageCnt(Math.ceil(result.count / offset));
      setRows(result.rows);
      if (e?.target) {
        setPage(1);
      }
    }
  };

  const getNoticeList = async (e) => {
    let params = {
      kind,
      category: progSelected,
      isNotice: true
    };

    const response = await axios.get(`/api/board/${kind}`, { params });
    if (response.data) {
      const result = response.data;
      setNoticeRows(result);
    }
  };

  const getProgList = async (e) => {
    const response = await axios.get(`/api/pgm`, { params: { viewYn: true, kind: 'public' } });
    response.data.unshift({ engNm: 'common', korNm: '공통' });
    await setProgItem(response.data);
    await setProgSelected(response.data.map((t) => t.engNm));
  };

  const handleChangeMultiSelect = (event) => {
    const {
      target: { value, name }
    } = event;

    if (value[value.length - 1] === 'all') {
      const items = progItem.map((t) => t.engNm);
      setProgSelected(progSelected.length === progItem.length ? [] : items);
      return;
    }
    setProgSelected(value);
  };

  const createBoard = async (e) => {
    navigate('/register', {
      state: {
        name,
        kind,
        categoryItem: progItem,
        file
      }
    });
  };

  useEffect(async () => {
    if (!!category) {
      getProgList();
    }
  }, []);

  useEffect(async () => {
    await getNoticeList();
    await getDataList(page);
  }, [page, kind]);

  return (
    <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        {name}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Stack direction="row" spacing={2}>
            <TextField id="subjectSrch" variant="outlined" size="small" label="제목" value={srchData?.subject || ''} onChange={handleChangeSrch} />
            <TextField id="createdIdSrch" variant="outlined" size="small" label="등록자" value={srchData?.createdId || ''} onChange={handleChangeSrch} />
            <Button variant="contained" onClick={getDataList}>
              검색
            </Button>
          </Stack>
          <TableContainer component={'div'}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth }}>
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {noticeRows.map((row, rowIdx) => (
                  <TableRow hover key={row.id} onClick={handleRowClick(row)}>
                    {columns.map((col, colIdx) => (
                      <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.subjectAlign || col.align}>
                        {col.id === 'id' ? '공지' : row[col.id]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
                {rows.map((row, rowIdx) => (
                  <TableRow hover key={row.id} onClick={handleRowClick(row)}>
                    {columns.map((col, colIdx) => {
                      return (
                        <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.subjectAlign || col.align}>
                          {col.id === 'subject' && row['parent_id'] != row['id'] ? <SubdirectoryArrowRightIcon fontSize={'small'} sx={{ ml: row['level'] * 2 }} /> : ''}
                          {col.id === 'status_nm' && row['parent_id'] != row['id'] ? '' : row[col.id]}
                          {col.id === 'subject' && row['is_secret'] ? <LockIcon fontSize={'small'} /> : ''}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Container maxWidth="sm" sx={{ mt: 2 }}>
              <Pagination count={pageCnt} page={page} onChange={handleChangePage} showFirstButton showLastButton />
            </Container>
            <Stack direction="row" spacing={2} justifyContent="flex-end">
              <Button variant="contained" onClick={createBoard}>
                글쓰기
              </Button>
            </Stack>
          </TableContainer>
        </Grid>
      </Grid>
    </Paper>
  );
}
